module.exports = __webpack_public_path__ + "static/desktop-screen-138fb93cf497ae0af79af04d270a126a.jpg";